import { createSelector } from "@reduxjs/toolkit";

import {
    IMattressMatchResults,
    IProduct,
} from "../../models/catalogue.interfaces";
import { ICustomerMatchPoint } from "./models.interfaces";
import { IReduxState } from "./reducers.interfaces";

export const userMatchPoint = createSelector(
    [(state: IReduxState) => state.ui.selections.selectedBudget],
    (selectedBudget): ICustomerMatchPoint | undefined => {
        return {
            optionValues: {
                budget_rank: selectedBudget || 1,
                firmness: 0,
            },
        };
    },
);

export const matchEnabledProducts = createSelector(
    [(rootProducts: IProduct[]) => rootProducts],
    (rootProducts): IProduct[] => {
        return rootProducts.filter((p) => {
            return (
                !p.category_names.includes("Discontinued") &&
                !p.category_names.includes("Closeout") &&
                (p.attributes.firmness || true) &&
                (p.attributes.budget_rank || true)
            );
        });
    },
);

export const mostSimilarProducts = (
    state: IReduxState,
): IMattressMatchResults | null => {
    if (!state.ui.loadedResults) {
        return null;
    }
    return state.ui.loadedResults;
};
